export const baseUrls = {
  authn: `/authns`,
  chargeApi: `/location/charge/`,
  stationApi: `/location/site/evses/`,
  stationNameApi: `/location/site/`
}
